import { Stack, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import SignInForm from "./Form";

function SignIn(props) {
  return (
    <Stack spacing="1rem">
      <Text
        color="gray.700"
        fontWeight="700"
        fontSize="1.5rem"
        textAlign="center">
        <FormattedMessage defaultMessage="Accéder à votre espace client" />
      </Text>

      <SignInForm />
    </Stack>
  );
}

export default SignIn;
